import { useState, useCallback } from "react";
import { SiteHeader } from "../components/SiteHeader";
import { Hero } from "../components/Hero";
import { PainPointSelector } from "../components/PainPointSelector";
import { ResultsView } from "../components/ResultsView";
import { SuccessStories } from "../components/SuccessStories";
import { BookingModal } from "../components/BookingModal";
import { createAssessment } from "../lib/api";
import { Sparkles } from "lucide-react";

export default function Dashboard() {
  const [businessType, setBusinessType] = useState("");
  const [selectedPains, setSelectedPains] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);

  const togglePain = useCallback((id) => {
    setSelectedPains((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]
    );
  }, []);

  const scrollToWizard = () => {
    document.getElementById("wizard")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleSaveAssessment = async (payload) => {
    try {
      await createAssessment(payload);
    } catch (e) {
      // non-blocking
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader onBook={() => setBookingOpen(true)} />

      {!showResults && (
        <>
          <Hero onStart={scrollToWizard} onBook={() => setBookingOpen(true)} />
          <PainPointSelector
            businessType={businessType}
            setBusinessType={setBusinessType}
            selectedPains={selectedPains}
            togglePain={togglePain}
            onShowPlan={() => setShowResults(true)}
          />
        </>
      )}

      {showResults && (
        <ResultsView
          businessType={businessType}
          selectedPains={selectedPains}
          onBack={() => setShowResults(false)}
          onBook={() => setBookingOpen(true)}
          onSaveAssessment={handleSaveAssessment}
        />
      )}

      <SuccessStories />

      <footer className="border-t border-border bg-card py-10">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
              <Sparkles className="h-4 w-4 text-primary-foreground" />
            </span>
            <span className="font-heading font-bold text-primary">Nexo AI Lab</span>
          </div>
          <p className="text-sm text-muted-foreground text-center">
            Ayudamos a pequeños negocios a trabajar menos y ganar más con IA del día a día.
          </p>
          <button
            onClick={() => setBookingOpen(true)}
            data-testid="footer-book-btn"
            className="text-sm font-semibold text-accent hover:underline"
          >
            Agenda una llamada gratis →
          </button>
        </div>
      </footer>

      <BookingModal
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        defaults={{ business_type: businessType, pain_point: selectedPains[0] || "" }}
      />
    </div>
  );
}
